import { Component, OnInit } from '@angular/core';
import { AppService } from '../../services/app.service';
import { Location } from "@angular/common";

@Component({
  selector: 'app-mappedin',
  templateUrl: './mappedin.page.html',
  styleUrls: ['./mappedin.page.scss'],
})
export class MappedinPage implements OnInit {
  flags: any;

  constructor(public app: AppService, private location: Location) { 
    this.flags = {
      src: null,
    };
    
  }



  viewPage(m, id) {
    if(m == 0) {
      //this.router.navigateByUrl('/slides-folder/' + this.folder);
      this.location.back();
    }
  }


  ngOnInit() {
  }

}
